import { login, logout, loginIndex } from "@/api/modules/login";

import {
  selectExchangeInfoList,
  selectExchangeInfoDetail,
  selectCertificateInfoList,
  updateCertificate,
  selectExchangeInfoFileDetail
} from "@/api/modules/dataExchange";

import {
  getOrgUserList,
  addOrgUser,
  getFatherOrgList,
  freezeOrgAccount,
  invalidOrgAccount,
  getTradeInfoList,
  getOrgUserDetail,
  resetPassword,
  updateOrgUserDetail,
  importApplyInfo,
  exportOrgInfo,
  synchroOrgInfo,
  selectOrgApplyList,
  queryOrganization
} from "@/api/modules/accountAdmin";

import {
  getCensusBusiness,
  setCensusBusiness,
  getCensusUser,
  setCensusUser,
  businessStatistics,
  querySurvival
} from "@/api/modules/statistics";

import {
  getManagerUserList,
  addManagerUserInfo,
  freezeManageUser,
  invalidManageUser,
  getManagerUserDetail,
  updateManageUserDetail,
  getRoleList,
  getRoleAuthorityList,
  addRole,
  setRoleAuthority,
  getNoticeList,
  sendNotice
} from "@/api/modules/install";

import {
  getApplyList,
  getApplyDetail,
  updateApplyDetail,
  exportArrangeFile,
  getDictionaryList,
  deleteDictionary,
  insertOrUpdateDictionary,
  updateDictionary,
  addApplyInfo,
  getAddApplyInfo,
  synchroClassInfo,
  pianapplist
} from "@/api/modules/applyMange";

import {
  getBuyList,
  sendBuyWarning,
  getBuyDetail,
  getBuyHistoryList,
  buyService,
  updateBuyWarning
} from "@/api/modules/costAdmin";

import {
  getCompanyList,
  getOrgListForInputEv,
  getInputEvList,
  exportInputEvList,
  getInputEvDetail,
  selectOutputEvList,
  selectDataDirInit,
  selectDataDirInfoList
} from "@/api/modules/exEvidenceAdmin";

import {
  getDataModelList,
  publishApply,
  publishApplyToEmall,
  getDataModelDetail,
  updateAuthority,
  getCompanyTypeList,
  addOrEditCompanyType,
  delOrgType,
  obtainOrgTypeById,
  obtainOrgTypeNamesList,
  getClassList,
  addClassItem,
  obtainDictionariesByKeyword
} from "./modules/dataModelMall";

import {
  getRetrieveList,
  findRetrieve,
  urlMonitor,
  updateRetrieve,
  online,
  offline,
  createRetrieve,
  deleteRetrieve,
  getPackageList,
  createPackage,
  updatePackage,
  deletePackage,
  pushPackage,
  findPackage,
  pushRetrieveList,
  upgradeRetrieveList,
  createPackageVersion,
  deletePackageVersion
} from "./modules/upgrade";

import * as cloudInterface from "./modules/cloudInterface";
import * as screen from "./modules/screen";
export default {
  login,
  logout,
  getOrgUserList,
  addOrgUser,
  getApplyList,
  getApplyDetail,
  updateApplyDetail,
  exportArrangeFile,
  getDictionaryList,
  deleteDictionary,
  insertOrUpdateDictionary,
  updateDictionary,
  addApplyInfo,
  getCompanyList,
  getAddApplyInfo,
  getCensusBusiness,
  setCensusBusiness,
  getCensusUser,
  setCensusUser,
  businessStatistics,
  querySurvival,
  getFatherOrgList,
  getManagerUserList,
  addManagerUserInfo,
  freezeManageUser,
  invalidManageUser,
  getManagerUserDetail,
  updateManageUserDetail,
  getRoleList,
  getRoleAuthorityList,
  addRole,
  freezeOrgAccount,
  invalidOrgAccount,
  getTradeInfoList,
  getOrgUserDetail,
  resetPassword,
  updateOrgUserDetail,
  getBuyList,
  sendBuyWarning,
  getBuyDetail,
  getBuyHistoryList,
  buyService,
  updateBuyWarning,
  getOrgListForInputEv,
  getInputEvList,
  exportInputEvList,
  getInputEvDetail,
  setRoleAuthority,
  getNoticeList,
  sendNotice,
  importApplyInfo,
  selectOutputEvList,
  exportOrgInfo,
  synchroOrgInfo,
  selectOrgApplyList,
  selectDataDirInit,
  selectDataDirInfoList,
  selectExchangeInfoList,
  selectExchangeInfoDetail,
  selectCertificateInfoList,
  updateCertificate,
  synchroClassInfo,
  selectExchangeInfoFileDetail,
  loginIndex,
  getDataModelList,
  publishApply,
  publishApplyToEmall,
  getDataModelDetail,
  updateAuthority,
  getCompanyTypeList,
  addOrEditCompanyType,
  delOrgType,
  obtainOrgTypeById,
  obtainOrgTypeNamesList,
  getClassList,
  addClassItem,
  obtainDictionariesByKeyword,
  getRetrieveList,
  findRetrieve,
  urlMonitor,
  updateRetrieve,
  online,
  offline,
  createRetrieve,
  deleteRetrieve,
  getPackageList,
  createPackage,
  updatePackage,
  deletePackage,
  pushPackage,
  findPackage,
  pushRetrieveList,
  upgradeRetrieveList,
  createPackageVersion,
  deletePackageVersion,
  pianapplist,
  queryOrganization,
  ...cloudInterface,
  ...screen
};



// WEBPACK FOOTER //
// ./src/api/index.js